<template>
  <el-form ref="form" :inline="true" size="mini">
    <el-form-item>
      <el-tooltip placement="top">
        <div slot="content">Поиск по комментариям, клиентам, ID</div>
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Введите и нажмите Enter"
          v-model="localSearchString"
          @change="performSearch"
          clearable
        >
        </el-input>
      </el-tooltip>
    </el-form-item>
    <el-form-item>
      <SelectUser
        v-model="localCreator"
        @input="performSearch"
        placeholder="Оператор"
      />
    </el-form-item>
    <el-form-item>
      <el-date-picker
        v-model="localDateRange"
        @input="performSearch"
        type="datetimerange"
        align="right"
        start-placeholder="От"
        end-placeholder="До"
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-select
        class="bottom-space"
        placeholder="Тип даты"
        clearable
        filterable
        v-model="localDateType"
        @input="performSearch"
      >
        <el-option
          v-for="item in localDateTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="Разные дни">
      <el-tooltip placement="top">
        <div slot="content">
          Отфильтрует сделки, которые открыты в один день, а закрыты в другой
        </div>
        <el-switch
          v-model="localIsDifferentDay"
          :active-value="true"
          :inactive-value="false"
          @change="performSearch"
        >
        </el-switch
      ></el-tooltip>
    </el-form-item>
    <el-form-item label="Только открытые">
      <el-tooltip placement="top">
        <div slot="content">
          Покажет только те сделки, которые открыты
        </div>
        <el-switch
          v-model="localOnlyOpen"
          :active-value="true"
          :inactive-value="false"
          @change="performSearch"
        >
        </el-switch
      ></el-tooltip>
    </el-form-item>
    <el-form-item>
      <el-select
        class="bottom-space"
        placeholder="Баланс"
        clearable
        filterable
        :loading="ownBalanceAccountsLoading"
        v-model="localBalanceAcc"
        @input="performSearch"
      >
        <el-option
          v-for="item in ownBalanceAccounts"
          :key="item._id"
          :label="item.title"
          :value="item._id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="localBalanceAcc" label="Сумма от">
      <el-input-number
        v-model="localAmountFrom"
        label="Сумма от"
        :min="0"
        @change="performSearch"
      >
      </el-input-number>
    </el-form-item>
    <el-form-item v-if="localBalanceAcc" label="до">
      <el-input-number
        v-model="localAmountTo"
        label="Сумма до"
        :min="0"
        @change="performSearch"
      >
      </el-input-number>
    </el-form-item>

    <el-form-item>
      <!-- <el-button type="success" size="medium" @click="performSearch"
                >Поиск</el-button
              > -->
      <el-button
        v-if="isFiltered"
        type="danger"
        size="mini"
        @click="resetSearch"
        >Сбросить фильтры</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { getBalanceAccounts } from "@/api";
import SelectUser from "./SelectUser.vue";

export default {
  name: "ExchangesFilterForm",
  data: () => ({
    localDateTypeOptions: [
      {
        label: "Дата создания",
        value: "dateStart"
      },
      {
        label: "Дата обновления",
        value: "updatedAt"
      }
    ],
    // Отдельный, локальный список — специально не через vuex-модуль
    // balanceAccounts: та же самая шарится вкладкой "Балансы", и наш
    // notPaginate:true fetch сюда гонялся наперегонки с её собственным
    // (пагинированным) запросом в одно и то же состояние — кто ответит
    // последним, тот и остаётся, независимо от того, что было запрошено.
    // Список нужен только для выпадашки фильтра, ему незачем делить
    // состояние с другой вкладкой вообще.
    ownBalanceAccounts: [],
    ownBalanceAccountsLoading: false
  }),
  components: {
    SelectUser
  },
  computed: {
    ...mapState("ledgerExchanges", [
      "searchString",
      "creator",
      "dateRange",
      "dateType",
      "isFiltered",
      "isDifferentDay",
      "balanceAcc",
      "amountFrom",
      "amountTo",
      "onlyOpen"
    ]),
    localOnlyOpen: {
      get() {
        return this.onlyOpen;
      },
      set(val) {
        this.changeOnlyOpen({ onlyOpen: val });
      }
    },
    localIsDifferentDay: {
      get() {
        return this.isDifferentDay;
      },
      set(val) {
        this.changeIsDifferentDay({ isDifferentDay: val });
      }
    },
    localSearchString: {
      get() {
        return this.searchString;
      },
      set(val) {
        this.changeSearchString({ searchString: val });
      }
    },
    localCreator: {
      get() {
        return this.creator;
      },
      set(val) {
        this.changeCreator({ creator: val });
      }
    },
    localDateRange: {
      get() {
        return this.dateRange;
      },
      set(val) {
        this.changeDateRange({ dateRange: val });
      }
    },
    localDateType: {
      get() {
        return this.dateType;
      },
      set(val) {
        this.changeDateType({ dateType: val });
      }
    },
    localBalanceAcc: {
      get() {
        return this.balanceAcc;
      },
      set(val) {
        this.changeBalanceAcc({ balanceAcc: val });
      }
    },
    localAmountFrom: {
      get() {
        return this.amountFrom;
      },
      set(val) {
        this.changeAmountFrom({ amountFrom: val });
      }
    },
    localAmountTo: {
      get() {
        return this.amountTo;
      },
      set(val) {
        this.changeAmountTo({ amountTo: val });
      }
    }
  },
  methods: {
    ...mapActions("ledgerExchanges", [
      "changeSearchString",
      "changeCreator",
      "changeIsDifferentDay",
      "changeDateRange",
      "changeDateType",
      "performSearch",
      "resetSearch",
      "changeBalanceAcc",
      "changeAmountFrom",
      "changeAmountTo",
      "changeOnlyOpen"
    ]),
    async fetchOwnBalanceAccounts() {
      try {
        this.ownBalanceAccountsLoading = true;
        const { data } = await getBalanceAccounts({ pagination: false });
        if (data.status) this.ownBalanceAccounts = data.result.docs;
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.ownBalanceAccountsLoading = false;
      }
    }
  },
  async mounted() {
    await this.fetchOwnBalanceAccounts();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/ui/ExchangesFiltersForm.vue